import { render, staticRenderFns } from "./AppPayDialog.vue?vue&type=template&id=54842995&scoped=true&"
import script from "./AppPayDialog.vue?vue&type=script&lang=js&"
export * from "./AppPayDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppPayDialog.vue?vue&type=style&index=0&id=54842995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54842995",
  null
  
)

export default component.exports